import { makeStyles } from "@material-ui/core";

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "100%",
    // paddingTop: theme.spacing(8),
    "& .MuiDivider-root": {
      marginBottom: theme.spacing(4)
    }
  },
  drawerPaper: {
    width: drawerWidth,
    position: "fixed",
    top: theme.spacing(8),
    zIndex: "1",
    borderRight: "none"
  },
  content: {
    flexGrow: 1,
    boxSizing: "border-box",
    padding: theme.spacing(3),
    // marginTop: theme.spacing(5),
    width: `calc( 100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth
  },
  titleSection: {
    display: "flex",
    alignItems: "flex-end",
    marginBottom: "24px !important",
    marginTop: "32px !important",
    "& h4": {
      marginRight: "16px !important"
    }
  },
  searchTitle: {
    marginBottom: theme.spacing(2)
  },
  createCompanyBtn: {
    marginTop: 0
    // marginTop: theme.spacing(4),
    // marginBottom: theme.spacing(4),
  },
  companyTreeHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2)
  },
  companyTreeAction: {
    display: "flex",
    justifyContent: "space-between"
  },
  // companyTreeTitle: {
  //   marginBottom: theme.spacing(2),
  // },
  companyTreeContent: {
    //padding: '24px !important',
  },
  treeOuter: {
    maxHeight: "400px",
    minHeight: "400px"
  },
  popupIndicatorOpen: {
    display: "none"
  },
  popupIndicator: {
    display: "none"
  },
  searchInput: {
    position: "relative",
    width: 342,
    marginRight: theme.spacing(2),
    // width: '40vw !important',
    //  marginBottom: 36,
    "& .MuiFormControl-root": {
      width: "100% !important"
    }
  },
  searchIcon: {
    position: "absolute",
    top: 10,
    right: 12
  },
  clearIndicator: {
    right: 46
  },
  customInput: {
    "& .MuiOutlinedInput-input": {
      padding: "13.5px 14px"
    },
    "& .MuiInputLabel-formControl:not(& .MuiInputLabel-outlined.MuiInputLabel-shrink)":
      {
        top: -7
      }
  },
  groupWrapper: {
    display: "flex",
    flex: 1,
    width: "100%",
    height: "100%",
    minWidth: 0,
    minHeight: 0
  },
  sizableGroupWrapper: {
    height: "100% !important",
    marginRight: 20,
    flex: "none",
    overflow: "hidden"
  },
  sizableGroupList: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    overflowX: "hidden",
    overflowY: "auto"
  },
  sizablePaper: {
    height: "100%"
  },
  announcementList: {
    padding: "20px",
    width: "100%",
    height: "100%",
    overflow: "auto"
  },
  announcementContent: {
    padding: "20px",
    width: "100%",
    height: "100%",
    overflow: "auto"
  },
  annContent: {
    overflow: "auto",
    backgroundColor: "#fff",
    borderRadius: 20,
    padding: "28px 20px",
    height: "calc(100% - 100px)"
  },
  contentSection: {
    margin: "0 auto",
    width: 1000
  },
  contentTitleSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 24,
    "& h5": {
      marginRight: "16px !important"
    }
  },
  announcementConfig: {
    padding: "15px 15px 1px",
    borderRadius: 10,
    backgroundColor: "#f1f1f1",
    display: "flex",
    flexWrap: "wrap",

    "& .ant-form-item": {
      width: "50%"
    }
  },
  annTitle: {
    color: "#00AFC6",
    fontSize: 20,
    fontWeight: 500,
    marginTop: 32,
    display: "flex",
    justifyContent: "space-between"
  },
  annText: {
    fontSize: 16,
    fontWeight: 500,
    marginTop: 16,
    color: "#33333B",

    "& table": {
      borderCollapse: "collapse",
      borderSpacing: 0,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      width: "100%",
      borderTop: "1px solid #ccc",
      borderLeft: "1px solid #ccc"
    },

    "& table th, & table td": {
      padding: "6px 8px",
      whiteSpace: "break-spaces",
      borderBottom: "1px solid #ccc",
      borderRight: "1px solid #ccc",
      textAlign: "left"
    }
  },
  annTime: {
    fontSize: 16,
    fontWeight: 500,
    marginTop: 10,
    color: "#33333B"
  },
  fileList: {
    marginTop: 16
  },
  fileItem: {
    display: "flex",
    alignItems: "center",
    height: 30
  },
  fileItemName: {
    fontWeight: 500,
    color: "#00AFC6",
    fontSize: 16,
    cursor: "pointer"
  }
}));

export default useStyles;
